<template>
  <div  :class="classes">
    <pt-page-title title="20周年活动" :isSearch="true" @search="search" :searchKey="searchKey"  @emptySearch="emptySearch"></pt-page-title>
    <pt-active-sign-table :class="$style['pt-active-sign']" :searchKey="searchKey" :isParseSign="isParseSign" :isQuestionnaire="isQuestionnaire" :tableLabels="tableLabels" type="TWENTIETH_ANNIVERSARY_ACT">
      <el-table-column label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="copyLink(scope.row)" v-clipboard:copy="copyContent(scope.row)" v-clipboard:success="onCopy" v-clipboard:error="onError">复制链接</el-button>
          <!-- <el-button type="text" @click="getDetail(scope.row)">详情</el-button> -->
          <el-button type="text" @click="signList(scope.row)">报名记录</el-button>
        </template>
      </el-table-column>
    </pt-active-sign-table>
  </div>
</template>

<script>
// 组件class前缀
import ptActiveSignTable from './anniversary-active-sign-table'
import { activeSignTableLabels } from '../pt-active-sign/active-sign.js'
const prefixCls = 'pt-anniversary-active-sign'
export default {
  name: 'pt-anniversary-active-sign',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    isParseSign () {
      return this.$route.name === 'parse-sign'
    },
    // 调查问卷
    isQuestionnaire () {
      return this.$route.name === 'questionnaire-sign'
    }
  },
  components: {
    ptActiveSignTable
  },
  data () {
    return {
      searchKey: null,
      isLoad: false,
      tableLabels: activeSignTableLabels
    }
  },
  watch: {
    '$route.name' (val) {

    }
  },
  methods: {
    search (val) {
      this.searchKey = val
    },
    emptySearch () {
      this.searchKey = null
    },
    copyLink (row) {

    },
    onCopy () {
      this.$message.success('复制成功，请前往您需要的位置粘贴')
    },
    onError () {
      this.$message.error('复制失败')
    },
    copyContent (row) {
      return '/sign-form?id=' + row.id
    },
    getDetail (row) {},
    signList (row) {
      let link
      switch (row.type) {
        case 'QUESTIONNAIRE':
          link = '/save-sign/question-sign-notes/' + row.name + '/' + row.id
          break
        case 'PARSE':
          link = '/parse-sign/parse-sign-notes/' + row.name + '/' + row.id
          break
        default:
          link = '/save-sign/active-sign-notes/' + row.name + '/' + row.id
          break
      }
      // let link = this.isParseSign ? ('/parse-sign/parse-sign-notes/' + row.name + '/' + row.id) : ('/save-sign/active-sign-notes/' + row.name + '/' + row.id)
      this.$router.push(link)
    }
  },
  created () {

  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-active-sign{
  :global
  .el-button{
    margin-left: 0;
    margin-right: 10px
  }
}
</style>
